import _ from 'lodash';
import { EmailContact } from '../store/samwin/email/email-behaviour/email-contact';

export function formatEmailReceivers(str: string): string {
   return str
      .split(';')
      .map((item) => item.trim())
      .join(';')
      .split(',')
      .map((item) => item.trim())
      .join(';')
      .split(' ')
      .map((item) => item.trim())
      .join(';');
}

export function emailArrayToString(str: string[], separator: string = ';'): string {
   return str?.map((item) => item.trim()).join(separator);
}

export function emailContactToString(str: EmailContact[], separator: string = ';'): string {
   return str?.map((item) => item.email.trim()).join(separator);
}

export function emailStringToContact(str: string): EmailContact[] {
   if (_.isEmpty(str.trim())) {
      return [];
   }
   return formatEmailReceivers(str)
      .split(';')
      .map((email) => new EmailContact(email));
}

export function isValidEmail(str: string): boolean {
   const emailValidator = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
   return emailValidator.test(str);
}
